module.exports = __webpack_public_path__ + "img/ck.dce00277.svg";